// Affiliate Application Status Constants
export const AFFILIATE_STATUS = {
  REV: "REV", // Application is waiting for review
  REJ: "REJ", // Application was rejected
  CCP: "CCP", // Need to create connected account for payout
  ACT: "ACT", // Affiliate is active
};

// Helper function to get status display name
export const getAffiliateStatusName = (status) => {
  switch (status) {
    case AFFILIATE_STATUS.REV:
      return "Under Review";
    case AFFILIATE_STATUS.REJ:
      return "Rejected";
    case AFFILIATE_STATUS.CCP:
      return "Pending Connected Account";
    case AFFILIATE_STATUS.ACT:
      return "Active";
    default:
      return "Not Started";
  }
};
